import { createFileRoute } from "@tanstack/react-router";

import { seo } from "@/lib/seo";
import { localBusinessSchema } from "@/lib/business";
import { assertDraftRouteVisible } from "@/lib/draft-routes";
import { PagePlaceholder } from "@/components/site/PagePlaceholder";

// Draft route: 404s on the live domain, renders normally elsewhere. See src/lib/draft-routes.ts.
export const Route = createFileRoute("/_site/about")({
  beforeLoad: assertDraftRouteVisible,
  head: () =>
    seo({
      title: "About LAA Concierge Consulting",
      description: "Who we are, how we work, and why founders hire us for funding-critical work. Las Vegas, NV, serving clients nationwide.",
      path: "/about",
      noindex: true,
      jsonLd: localBusinessSchema,
    }),
  component: Page,
});

function Page() {
  return <PagePlaceholder title={"About LAA Concierge Consulting"} intro={"[SUPPLY: firm story, founding date, team bios]"} />;
}
